/**
 * Rapid tracking is disabled. This script is a polyfill for the old logic.
 */
(function () {
    'use strict';

    function trackElements(selector, elementConfigs) {
        // Rapid tracking is disabled. Do nothing
    }

    /* global MW */
    MW.modules.rapid = {
        trackElements: trackElements
    };

})();
